import { omit } from 'lodash';
import { venomHistory } from 'client/utils/history/venom-history';
import { getSrpBrowserQuery } from 'site-modules/shared/utils/inventory/srp-utils';

export const CORE_SRP_INVENTORY_COUNT = { true: 3, false: 2 };
export const CONSTANT_FILTERS = ['make', 'model', 'initialUrlPattern', 'pageSize'];

export function getInitialSearchFilter({ makeSlug, modelSlug, year }) {
  return {
    make: [makeSlug],
    model: [`${makeSlug}|${modelSlug}`],
    year: `${year}`,
  };
}

export function getUnknownLocationSearchFilter(isInternational) {
  return isInternational ? { national: true } : {};
}

export function addFiltersToQuery(pathname, filter) {
  const query = getSrpBrowserQuery(omit(filter, CONSTANT_FILTERS));

  venomHistory.push(`${pathname}${query ? `?${query}` : ''}`);
}
